// Textbaustein „vergriffen" für den Vortext der Rechnung in BONUS.
//
// Am PC kopiert ein Knopf diesen Satz in die Zwischenablage; eingefügt
// wird er in BONUS von Hand. Das Tracking schreibt der Kundin nichts
// selbst (Designprinzip 3) — es formuliert nur, was ein Mensch dann
// verwendet.
//
// Wortlaut vom Betreiber freigegeben (28.10.2026). Sie-Form, weil der
// Satz auf der Rechnung an die Kundschaft steht.

export type VergriffenTitel = {
  titel: string;
  autor: string | null;
  menge_vergriffen: number;
};

function nennung(t: VergriffenTitel): string {
  const autor = t.autor?.trim() ?? '';
  return autor === '' ? `„${t.titel.trim()}“` : `„${t.titel.trim()}“ von ${autor}`;
}

/**
 * Der Satz für alle vergriffenen Titel einer Bestellung — oder `null`,
 * wenn nichts vergriffen ist.
 */
export function vergriffenText(positionen: VergriffenTitel[]): string | null {
  const titel = positionen.filter((p) => p.menge_vergriffen > 0);
  if (titel.length === 0) return null;
  if (titel.length === 1) {
    return (
      `Leider ist der Titel ${nennung(titel[0])} inzwischen vergriffen und kann ` +
      'nicht mehr geliefert werden. Wir bitten um Ihr Verständnis.'
    );
  }
  return (
    'Leider sind die folgenden Titel inzwischen vergriffen und können nicht mehr ' +
    `geliefert werden: ${titel.map(nennung).join('; ')}. Wir bitten um Ihr Verständnis.`
  );
}
